import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './EntradaRender.css';

export const ENTRADA_DEFAULT_LAYOUT = {
  qrTop: 53,
  qrLeft: 50,
  qrSize: 260,
};

export const entradaNumber = (value, fallback = 50) => {
  if (typeof value === 'number') return value;
  const parsed = parseFloat(String(value ?? '').replace('%', ''));
  return Number.isFinite(parsed) ? parsed : fallback;
};

export function normalizarLayoutEntrada(layout) {
  if (!layout || typeof layout !== 'object') return { ...ENTRADA_DEFAULT_LAYOUT };
  return {
    qrTop: entradaNumber(layout.qrTop ?? layout.top, ENTRADA_DEFAULT_LAYOUT.qrTop),
    qrLeft: entradaNumber(layout.qrLeft ?? layout.left, ENTRADA_DEFAULT_LAYOUT.qrLeft),
    qrSize: entradaNumber(layout.qrSize ?? layout.size, ENTRADA_DEFAULT_LAYOUT.qrSize),
  };
}

export default function EntradaRender({
  fondo,
  id,
  layout,
  width = 300,
  className = '',
  showGuides = false,
  onImageLoad,
}) {
  const L = useMemo(() => normalizarLayoutEntrada(layout), [layout]);
  const [aspectRatio, setAspectRatio] = useState('9 / 16');

  const qrValue = id
    ? `https://www.rao-ing.shop/entrada/${id}`
    : 'https://www.rao-ing.shop/entrada/PREVIEW123';

  const qrSize = Math.max(80, Number(L.qrSize || ENTRADA_DEFAULT_LAYOUT.qrSize));
  const paddingQR = 10;
  const canvasSize = Math.max(60, qrSize - paddingQR * 2);

  const handleLoad = (event) => {
    const img = event.currentTarget;
    if (img?.naturalWidth && img?.naturalHeight) {
      setAspectRatio(`${img.naturalWidth} / ${img.naturalHeight}`);
    }
    onImageLoad?.(event);
  };

  return (
    <div
      id={id ? `ticket-${id}` : undefined}
      className={`palma-entrada-render ${showGuides ? 'palma-entrada-render--guides' : ''} ${className}`.trim()}
      style={{ width, aspectRatio }}
    >
      <img
        className="palma-entrada-bg"
        src={fondo || '/eventos/entrada.png'}
        alt="Entrada"
        onLoad={handleLoad}
        crossOrigin="anonymous"
        draggable="false"
      />

      <div
        className="palma-entrada-qr"
        style={{
          top: `${entradaNumber(L.qrTop, ENTRADA_DEFAULT_LAYOUT.qrTop)}%`,
          left: `${entradaNumber(L.qrLeft, ENTRADA_DEFAULT_LAYOUT.qrLeft)}%`,
          width: qrSize,
          height: qrSize,
          padding: paddingQR,
        }}
      >
        <QRCodeSVG
          value={qrValue}
          size={canvasSize}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
          includeMargin={false}
          style={{ display: 'block' }}
        />
      </div>
    </div>
  );
}
